/* eslint-disable @typescript-eslint/no-unused-vars */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken, getCSRF_Token } from "./localStorageService";
import { API_URL, INITIAL_TOKEN } from "../../config/config";
import { RootState } from "store";

export const baseApi = createApi({
  reducerPath: "baseApi",

  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers: Headers, api) => {
      // const state = api.getState() as RootState;
      headers.set("token", INITIAL_TOKEN);
      headers.set("Accept", "application/json");
      const auth_token = getToken();
      if (auth_token) {
        headers.set("authorization", auth_token);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
});
